import React from 'react';

export const QUESTIONNAIRE_INFO_STEP_IDS = {
  purpose: 'purpose',
  questionnaire: 'questionnaire'
};

export default function QuestionnaireInfoStep({ stepId }) {
  if (stepId === QUESTIONNAIRE_INFO_STEP_IDS.purpose) {
    return (
      <div className="space-y-5">
        <div className="space-y-2">
          <div className="ptcm-section-pill w-fit">Pourquoi cet outil</div>
          <div className="text-lg font-semibold text-ptcm-ink dark:text-gray-100">À quoi ça sert</div>
        </div>

        <div className="space-y-4 text-sm leading-6 text-ptcm-muted dark:text-gray-200">
          <p>
            Cet outil a pour objectif de mieux comprendre sa charge mentale et celle de son/sa partenaire.
            Il installe une base neutre pour ouvrir le dialogue sur la charge mentale au sein de son couple et
            améliorer le bien-être de chacun.e.
          </p>

          <div className="rounded-[24px] border border-ptcm-border bg-ptcm-panel/70 px-4 py-4 dark:border-gray-800 dark:bg-gray-900/40">
            <p>Grâce à ce calculateur vous pourrez :</p>
            <ul className="mt-2 list-disc pl-5 space-y-1">
              <li>Dresser un état des lieux</li>
              <li>Valoriser le travail domestique et/ou éducatif que vous réalisez ainsi que comment vous le vivez</li>
              <li>Prendre connaissance de la charge de votre partenaire et de son vécu</li>
            </ul>
          </div>

          <p className="font-medium text-ptcm-ink dark:text-gray-100">
            Rassurez-vous, cet outil n'a pas vocation à pointer du doigt ou à culpabiliser !
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <div>
        <div className="ptcm-section-pill w-fit">Mode d'emploi</div>
        <div className="text-lg font-semibold text-ptcm-ink dark:text-gray-100">
          Comment répondre au questionnaire
        </div>
        <p className="text-sm text-ptcm-muted dark:text-gray-300">
          Prenez quelques minutes pour comprendre comment répondre. Cela garantit un résultat plus juste.
        </p>
      </div>

      <div className="space-y-5 text-sm leading-6 text-ptcm-muted dark:text-gray-200">
        <p>
          Les affirmations sont regroupées par catégories (enfants, repas, maison, démarches...).
          Certaines ne vous concerneront peut-être pas. Dans ce cas, vous pouvez simplement les ignorer.
        </p>

        <div className="rounded-[24px] border border-ptcm-border bg-ptcm-panel/70 px-5 py-5 dark:border-gray-800 dark:bg-gray-900/40">
          <div className="font-semibold text-ptcm-ink dark:text-gray-100 mb-2">
            Pour chaque affirmation, vous répondez selon 3 axes
          </div>
          <ul className="list-disc pl-5 space-y-2">
            <li>
              <span className="font-medium">Ce que je fais</span>
              → La part réelle de cette tâche que vous effectuez dans une semaine normale.
            </li>
            <li>
              <span className="font-medium">Comment ça me pèse</span>
              → Le poids mental que cette tâche représenterait pour vous si vous deviez vous en occuper.
            </li>
            <li>
              <span className="font-medium">Qui pense à ça</span>
              → Qui a la responsabilité d'y penser et de s'assurer que cela soit fait.
            </li>
          </ul>
        </div>

        <div className="rounded-[20px] border border-ptcm-border bg-ptcm-panel/50 px-5 py-4 dark:border-gray-800 dark:bg-gray-900/30">
          <div className="font-semibold text-ptcm-ink dark:text-gray-100 mb-2">
            Quelques exemples pour bien comprendre
          </div>
          <ul className="space-y-2">
            <li>
              Si votre partenaire cuisine toujours mais que c'est vous qui
              pensez aux repas et planifiez les courses :
              <br />
              → <span className="font-medium">Ce que je fais :</span> peu
              <br />
              → <span className="font-medium">Qui pense à ça :</span> moi
            </li>
            <li>
              Si vous ne faites jamais une tâche parce qu'elle vous pèse beaucoup :
              <br />
              → vous pouvez indiquer qu'elle vous pèserait fortement même si vous ne la faites pas.
            </li>
            <li>
              Une tâche courte mais pénible peut peser plus qu'une tâche longue mais agréable.
              <br />
              → répondez selon votre ressenti, pas selon la durée.
            </li>
          </ul>
        </div>

        <p>
          Essayez de répondre le plus honnêtement possible selon votre perception personnelle,
          <span className="font-medium"> sans consulter votre partenaire</span>.
        </p>

        <p>
          Basez vos réponses sur une <span className="font-medium">semaine type</span>,
          lorsque votre foyer fonctionne normalement (hors vacances ou déplacements).
        </p>

        <p className="text-xs text-ptcm-muted dark:text-gray-400">
          Vous pourrez retrouver ces explications plus tard via le bouton d'aide du questionnaire.
        </p>
      </div>
    </div>
  );
}
